import { useFlags } from 'config/useFlagsContext'
import { Fragment, useMemo, useState } from 'react'

import { ProblemaCondicaoModel } from '../../model-problemasCondicoes'
import { NotificacaoAgravoCard } from './NotificacaoAgravoCard'
import { NotificacaoAgravoModalContainer } from './NotificacaoAgravoModalContainer'

interface NotificacaoAgravoSectionProps {
  problemasCondicoesAvaliados?: ReadonlyArray<ProblemaCondicaoModel>
}

export function NotificacaoAgravoSection(props: Readonly<NotificacaoAgravoSectionProps>) {
  const { problemasCondicoesAvaliados } = props

  const { API_SINAN_ENABLED } = useFlags()
  const [isNotificacaoAberta, setIsNotificacaoAberta] = useState(false)

  // TODO: filtrar pelos CID-10 de notificação compulsória (issue #35074).
  const cid10s = useMemo(() => (problemasCondicoesAvaliados ?? []).flatMap((item) => (item.cid ? [item.cid] : [])), [
    problemasCondicoesAvaliados,
  ])

  if (!API_SINAN_ENABLED || cid10s.isEmpty()) return null

  return (
    <Fragment>
      <NotificacaoAgravoCard
        nomesCid10={cid10s.map((cid10) => cid10.nome)}
        onPreencher={() => setIsNotificacaoAberta(true)}
      />

      {isNotificacaoAberta && (
        <NotificacaoAgravoModalContainer cid10s={cid10s} onClose={() => setIsNotificacaoAberta(false)} />
      )}
    </Fragment>
  )
}
